// extracted by mini-css-extract-plugin
export default {"invoice-page-layout":"style_invoice-page-layout__1HFuz","invoicePageLayout":"style_invoice-page-layout__1HFuz"};